import React from 'react';
import { useMobile } from '@octano/global-ui';
import { useFormContext } from 'react-hook-form';
import { QuestionType, ScaleOption } from '../types';

export type QuestionProps = {
  question: {
    id: string;
    text: string;
    type: QuestionType;
    evaluationScale?: { scaleOptions: ScaleOption[] } | null;
  };
  index: number;
};

const Question: React.FC<QuestionProps> = ({ question, index }) => {
  const {
    register,
    getValues,
    formState: { errors },
  } = useFormContext();

  const isMobile = useMobile();
  const fieldName = `responses.${question.id}`;
  const currentValue = getValues(fieldName);
  const hasError = errors.responses?.[question.id];
  const radioStyle = isMobile
    ? { marginRight: 8, height: 15, width: 15 }
    : { marginRight: 8, height: 20, width: 20 };

  return (
    <div style={{ marginBottom: 24 }}>
      <div
        style={{
          fontSize: 20,
          fontWeight: 'bold',
          marginBottom: 20,
        }}
      >
        {index + 1}. {question.text}
      </div>

      {question.type === QuestionType.SingleChoice &&
        question.evaluationScale?.scaleOptions.map((opt) => (
          <label
            key={opt.id}
            style={{
              display: 'flex',
              cursor: 'pointer',
              padding: '6px 0',
            }}
          >
            <input
              type="radio"
              value={opt.id}
              {...register(fieldName, {
                required: 'Selecciona una opción',
              })}
              style={radioStyle}
              checked={currentValue === opt.id}
            />
            <div style={{ fontSize: '16px', marginTop: -3 }}>
              {opt.description}
            </div>
          </label>
        ))}

      {hasError && (
        <div style={{ color: 'red', fontSize: 14, marginTop: 8 }}>
          {hasError.message?.toString()}
        </div>
      )}

      {question.type === QuestionType.MultipleChoice && (
        // desarrollar cuando se necesite
        <></>
      )}

      {question.type === QuestionType.Text && (
        // desarrollar cuando se necesite
        <></>
      )}
    </div>
  );
};

export default Question;
